import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

const ObjectItem = ({
  object,
  id,
  icon,
  pageIndex,
  onDelete,
  elementClasses,
  setActiveObject,
}) => {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
      className={elementClasses}
      onMouseDown={(e) => {
        e.stopPropagation();
        setActiveObject(object.id);
      }}
    >
      {icon}
      {object.name}
      <button
        className="delete-object"
        onMouseDown={(e) => {
          e.stopPropagation();
          onDelete(object.id);
        }}
      >
        <FontAwesomeIcon className="mR-10" icon={faTrash} />
      </button>
      {pageIndex != null && (
        <span className="pull-right">(page: {pageIndex})</span>
      )}
    </div>
  );
};

export default ObjectItem;
